<template>
  <div>
    <b-navbar
      class="d-none d-md-flex"
      :class="{shadow: scroll}"
      id="navbarText"
      style="background-color: #f8f7f4;"
    >
      <!-- <b-container-fluid> -->
      <b-navbar-brand href="/home" class="logo-container">
        <img
          :src="logoSrc"
          class="header-logo client-logo"
          alt="logo"
        />
      </b-navbar-brand>
	<!-- <h3><b><i>Consolidacion Estados Financieros {{compania}}</i></b></h3> -->
    <b-navbar-brand class="mx-auto">
      <!-- <h3><b class="headerNavbar">Aplicativo de Arrendamientos {{compania}}</b></h3> -->
      <div class="d-flex align-items-center mb-2">
        <img
          src="../../assets/LogoComplementCubeWhite.jpg"
          alt="Logo"
          style="width: 45px; height: 45px; object-fit: contain;"
        />
        <span
          class="font-weight-bold ml-2 text-white"
          style="font-size: 22px;"
        >
          <span style="color: #016690;">Cube</span> <span style="color: #ff924c;">Lease</span>
        </span>
    </div>
    </b-navbar-brand>

      <!-- <b-navbar-nav class="">
        <b-nav-item >
		{{$store.state.userName}}
        </b-nav-item >
        <b-nav-item @click.prevent="toggleLanguage()">
          <img
            src="../../assets/imgs/es.png"
            alt="es"
            v-if="language == 'es-ES'"
          />
          <img src="../../assets/imgs/en.png" alt="en"  v-else />
        </b-nav-item>
      </b-navbar-nav> -->
      <b-dropdown
        v-if="isAuthenticated"
        end
        variant="link"
        toggle-class="user-pill-toggle text-decoration-none"
        menu-class="user-pill-menu-wrap"
        class="ml-auto mr-3"
      >
        <template #button-content>
          <span class="font-weight-bold">{{ currentUserName }}</span>
        </template>
        <div class="user-pill-menu-holder">
          <button type="button" class="user-pill-menu-button" @click="logout()">
            <span v-if="language == 'es-ES'">Cerrar Sesión</span>
            <span v-else>Logout</span>
          </button>
        </div>
      </b-dropdown>
      <!-- </b-collapse> -->
      <!-- </b-container-fluid> -->
    </b-navbar>
  </div>
</template>

<script>
import Authentication from "@/services/Authentication"
import User from "@/services/User"

const imageContext = require.context("../../assets/imgs", false, /\.(png|jpe?g|svg)$/i);

export default {
	name: "AppHeader",
	data() {
		return {
			icono: "",
			compania: "",
			menu: "",
				home: "/#home",
				scroll: false,
				currentUserDisplayName: ""
		};
	},
beforeMount() {
    window.addEventListener("scroll", this.scrollFunction);
    if(this.$store.state.isAuthenticated){
    const now = new Date();
    const expiresIn = (new Date(this.$store.state.expiration)).getTime() - now.getTime();
    setTimeout(() => {
      console.log("YAY")
          this.logout()
    }, expiresIn);
    }
  },
  methods: {
    scrollFunction(e) {
      this.scroll = window.pageYOffset > 300
      e.preventDefault()
    },
    logout: function() {
      const obj = {
        token: "",
        username: "",
        role: "",
        expiresIn: "",
        isAuthenticated: false,
      };
      this.$store.commit("setData", obj);
      this.$router.push("/");
    },
    toggleLanguage() {
      if (this.$store.state._language == "es-ES") {
        this.$store.commit("setLang", "en-US");
      } else {
        this.$store.commit("setLang", "es-ES");
      }
    },
    loadCurrentUserName() {
      const userId = this.$store.state.userId;
      if (!this.$store.state.isAuthenticated || !userId) return;
      if (this.$store.state.userName) {
        this.currentUserDisplayName = this.$store.state.userName;
        return;
      }
      User.getAllUsersById(userId)
        .then((res) => {
          this.currentUserDisplayName = res?.data?.exiteUser?.[0]?.nombre || "";
        })
        .catch(() => {});
    },
  },
  computed: {
    logoSrc() {
      const fallback = imageContext("./logo-login.png");
      if (!this.icono) {
        return fallback;
      }

      const candidates = [this.icono, `${this.icono}.png`, `${this.icono}.jpg`, `${this.icono}.jpeg`];
      for (const file of candidates) {
        try {
          return imageContext(`./${file}`);
        } catch (e) {
          // Continue trying other extensions/names.
        }
      }
      return fallback;
    },
    role() {
      // console.log(this.$store.state.userRole)
      return this.$store.state.userRole;
    },
    isAuthenticated() {
      // console.log(this.$store.state.isAuthenticated)
      return this.$store.state.isAuthenticated;
    },
    language() {
      // console.log(this.$store.state._language)
      return this.$store.state._language;
    },
    currentUserName() {
      return this.$store.state.userName || this.currentUserDisplayName || "";
    },
	},
mounted() {
		Authentication.leaParametros()
		.then ((result) => {
			this.icono = result.data.parametros.icono
			this.compania = result.data.parametros.compania
		})
		this.loadCurrentUserName()
	}
}
</script>

<style>
/* d-none d-md-flex */
.navbar {
  z-index: 2;
  height: 65px;
  padding: 1.5rem 3rem !important;
}

.navbar-brand img {
  max-height: 45px;
}
.nav-link img {
  height: 35px !important;
  border-radius: 50%;
}
/* .navbar-brand .header-logo{
  position: absolute;
  top: 0;
  height: 80%;
} */
.dropdown-item.active,
.dropdown-item:active {
  /* color: #fff; */
  /* text-decoration: none; */
  background-color: rgb(210 20 64 / 12%) !important;
}
.dropdown-toggle::after {
  display: none !important;
  border: 0 !important;
}
.user-pill-toggle {
  background-color: var(--five) !important;
  color: #ffffff !important;
  border-radius: 999px !important;
  padding: 6px 14px !important;
  border: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  white-space: nowrap !important;
}
.user-pill-toggle:hover,
.user-pill-toggle:focus,
.user-pill-toggle:active {
  background-color: var(--five) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.user-pill-menu-wrap {
  min-width: unset !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 4px 0 0 0 !important;
}
.user-pill-menu-holder {
  display: flex;
  justify-content: flex-end;
  padding: 0 !important;
}
.user-pill-menu-button {
  background-color: #d80027 !important;
  color: #ffffff !important;
  border-radius: 999px !important;
  padding: 6px 14px !important;
  border: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-align: center !important;
  min-width: 0 !important;
  line-height: 1.2 !important;
  white-space: nowrap !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18) !important;
  appearance: none !important;
}
.user-pill-menu-button,
.user-pill-menu-button span,
.user-pill-menu-button * {
  color: #ffffff !important;
}
.user-pill-menu-button:hover,
.user-pill-menu-button:focus,
.user-pill-menu-button:active {
  background-color: #bf0022 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22) !important;
  outline: none !important;
}
#navbarText {
  font-size: 1.1rem !important;
}
#navbarText li {
  line-height: 1.5rem;
}
.navbar svg {
  font-size: 1.5rem !important;
}
.fas {
  font-size: 4.5rem !important;
  height: auto;
  width: auto;
  color: rgba(250, 250, 250, 0.4);
}
.login-btn {
  background: var(--five);
  border-radius: 38px;
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  overflow: hidden;
  width: 125px;
  font-size: 14px;
}
.login-btn a span {
  color: #f6f1f2;
}
.login-btn:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(250, 250, 250, 0.2);
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.login-btn:hover,
.login-btn:focus,
.login-btn:active {
  color: white;
}
.login-btn:hover:before,
.login-btn:focus:before,
.login-btn:active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
  -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
}
.float-menu {
  position: fixed;
  bottom: 1.4rem;
  left: 1rem;
  width: 50px;
  height: 50px;
  border-radius: 50% 50% 50% 50%;
  background: #b11a4b;
  box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 800;
}

.float-menu span {
  z-index: 5;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  transition: 0.3s ease-in-out;
  color: #f6f1f2;
}

.float-menu span:nth-child(2) {
  opacity: 0;
}

.float-menu.active span {
  transform: rotate(135deg);
}

.float-menu.active span:nth-child(2) {
  opacity: 1;
}

.float-menu.active span:nth-child(1) {
  opacity: 0;
}

.float-menu ul {
  position: absolute;
  bottom: 1rem;
  background: #fff;
  min-width: 150px;
  padding: 20px 0;
  border-radius: 25px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
}

.float-menu ul li {
  padding: 10px 20px;
  font-size: 1.2rem;
  text-align: left;
}

.float-menu.active ul {
  bottom: 4rem;
  opacity: 1;
  visibility: visible;
}

.float-menu.active ul li:hover {
  background: #f8f9fa;
}

.float-menu ul li a {
  width: 100%;
}

.client-logo {
  filter: grayscale(100%);
}
</style>
